'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.fetchCoupons = fetchCoupons;
exports.fetchCouriers = fetchCouriers;
exports.fetchProductTypes = fetchProductTypes;
exports.fetchOrders = fetchOrders;
exports.updateOrder = updateOrder;
exports.cancelOrder = cancelOrder;
exports.fetchProducts = fetchProducts;
exports.postProduct = postProduct;
exports.fetchTemplates = fetchTemplates;
exports.postTemplate = postTemplate;
exports.deleteTemplate = deleteTemplate;
exports.fetchFinances = fetchFinances;
exports.fetchInouts = fetchInouts;
exports.fetchUsers = fetchUsers;
exports.postUser = postUser;
exports.fetchLevels = fetchLevels;
exports.login = login;
exports.register = register;
exports.fetchCaptcha = fetchCaptcha;
exports.fetchPickupStations = fetchPickupStations;
exports.fetchShippingTemplates = fetchShippingTemplates;
exports.fetchMedia = fetchMedia;
exports.postMedia = postMedia;
exports.fetchUploadSign = fetchUploadSign;
exports.postPackage = postPackage;
exports.postRefund = postRefund;
exports.fetchHomeData = fetchHomeData;
exports.fetchBannerData = fetchBannerData;
exports.updateBannerData = updateBannerData;
exports.deleteBannerData = deleteBannerData;
exports.fetchResellers = fetchResellers;
exports.fetchWithDraws = fetchWithDraws;
exports.updateWithDrawStatus = updateWithDrawStatus;

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _store = require('../store');

var _store2 = _interopRequireDefault(_store);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _utils = require('../utils');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var url = require('url');
var querystring = require('querystring');

/**
* 获取优惠券列表
*/
function fetchCoupons(filter) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var token = _utils.ls.getItem('token');
    var q = {
        page: page
    };
    return _axios2.default.get(_constants.API_ENDPOINTS.coupons, {
        params: q,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}
/**
 * 获取快递公司列表
 * @return {[type]} [description]
 */
function fetchCouriers() {
    var token = _utils.ls.getItem('token');
    return _axios2.default.get(_constants.API_ENDPOINTS.couriers, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

function fetchProductTypes() {
    var token = _utils.ls.getItem('token');
    return _axios2.default.get(_constants.API_ENDPOINTS.productTypes, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

function fetchOrders(filter, page) {
    filter = filter || {};
    page = page || 1;
    var token = _utils.ls.getItem('token');
    var q = {
        page: page
    };
    if (filter.status !== -1) {
        q.status = filter.status;
    }
    if (filter.keyword && filter.keyword.length > 0) {
        q.keyword = filter.keyword;
    }
    if (filter.date && filter.date.length === 2) {
        q.begin = +(0, _moment2.default)(filter.date[0]);
        q.end = +(0, _moment2.default)(filter.date[1]);
    }
    return _axios2.default.get(_constants.API_ENDPOINTS.orders, {
        params: q,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

function updateOrder(id) {
    var token = _utils.ls.getItem('token');
    return _axios2.default.post(_constants.API_ENDPOINTS.orders + '/' + id + '/manufacture', {}, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

function cancelOrder(id, value) {
    var token = _utils.ls.getItem('token');
    return _axios2.default.post(_constants.API_ENDPOINTS.orders + '/' + id + '/cancel', value, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

function fetchProducts() {
    var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var token = _utils.ls.getItem('token');
    var q = {
        page: page
    };
    if (filter.type !== -1) {
        q.product_type_id = filter.type;
    }
    if (filter.status !== -1) {
        q.status = filter.status;
    }
    if (filter.keyword && filter.keyword.length > 0) {
        q.keyword = filter.keyword;
    }
    return (0, _isomorphicFetch2.default)(_constants.API_PRODUCTS + '?' + querystring.stringify(q), {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}
function postProduct(values) {
    var keys = ['code', 'weight', 'price', 'templates'];
    var token = _utils.ls.getItem('token');
    var data = {
        default_order: values.sort,
        tags: values.tags,
        title: values.title,
        sub_title: values.subTitle,
        status: values.status,
        skus: values.spec && values.spec.prices.map(function (x) {
            var sku = { specification: {} };
            for (var key in x) {
                if (keys.indexOf(key) !== -1) {
                    sku[key] = x[key];
                    if (key === 'price') {
                        sku[key] = Number(x[key]);
                    } else if (key === 'templates') {
                        sku[key] = x[key].map(function (x) {
                            return Number(x);
                        });
                    }
                } else {
                    // key: 尺寸，x[key]：6寸

                    for (var i = 0; i < values.spec.addedSpecs.length; i++) {
                        var name = values.spec.addedSpecs[i].name;
                        if (name === key) {
                            if (values.spec.addedSpecs[i].values.indexOf(x[key]) !== -1) {
                                sku.specification[key] = x[key];
                                break;
                            }
                        }
                    }
                }
            }
            if (Object.keys(sku.specification).length > 0) {
                return sku;
            }
        }),
        'preview_images': values.preview && values.preview.map(function (x) {
            return x.id;
        }),
        'description_images': values.desc && values.desc.map(function (x) {
            return x.id;
        }),
        'default_image': values.defaultImage && values.defaultImage[0].id,
        un_need_customize: values.un_need_customize
    };
    data.skus = data.skus && data.skus.filter(function (x) {
        return x;
    });
    if (typeof values.type !== 'undefined') {
        data.product_type_id = parseInt(values.type);
    }
    if (typeof values.shipping_fee !== 'undefined') {
        data.shipping_fee = Number(values.shipping_fee);
    }

    if (typeof values.id !== 'undefined') {
        // 更新
        return _axios2.default.put(_constants.API_PRODUCTS + '/' + values.id, data, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
    } else {
        // 新增
        return _axios2.default.post(_constants.API_PRODUCTS, data, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
    }
}

/**
 * 获取模版列表
 * @param  {[type]} filter [description]
 * @return {[type]}        [description]
 */
function fetchTemplates() {
    var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var token = _utils.ls.getItem('token');
    var q = {};
    if (filter.type !== -1) {
        q.product_type_id = filter.type;
    }
    if (filter.status !== -1) {
        q.status = filter.status;
    }
    if (filter.keyword && filter.keyword.length > 0) {
        q.keyword = filter.keyword;
    }
    return _axios2.default.get(_constants.API_TEMPLATES, {
        params: q,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

function postTemplate(values) {
    var token = _utils.ls.getItem('token');
    var data = {
        default_order: values.sort,
        source_file: values.url,
        title: values.title,
        sub_title: values.subTitle,
        default_image: values.defaultImage && values.defaultImage[0].id,
        product_type_id: parseInt(values.type),
        status: values.status
    };
    if (typeof values.id !== 'undefined') {
        // 更新
        return _axios2.default.put(_constants.API_TEMPLATES + '/' + values.id, data, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
    } else {
        // 新增
        return _axios2.default.post(_constants.API_TEMPLATES, data, {
            headers: {
                'Authorization': 'Bearer ' + token
            }
        });
    }
}

function deleteTemplate(id) {
    var token = _utils.ls.getItem('token');
    return _axios2.default.delete(_constants.API_TEMPLATES + '/' + id, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

/**
 * 获取交易明细列表
 * @param  {[type]} filter [description]
 * @return {[type]}        [description]
 */
function fetchFinances(filter) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var token = _utils.ls.getItem('token');
    var q = {};
    if (filter.date[0]) {
        q.begin = filter.date[0] / 1000;
        q.end = filter.date[1] / 1000;
    }
    if (filter.type) {
        q.type = filter.type;
    }
    q.keyword = filter.keyword;
    q.page = page;
    return _axios2.default.get(_constants.API_FINANCES, {
        params: q,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

/**
 * 获取收支统计列表
 * @param  {[type]} filter [description]
 * @return {[type]}        [description]
 */
function fetchInouts(filter) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var token = _utils.ls.getItem('token');
    var q = {};
    q.begin = Date.parse(filter.date[0] + ' 00:00:00') / 1000;
    q.end = Date.parse(filter.date[1] + ' 23:59:59') / 1000;
    return _axios2.default.get(_constants.API_INOUT, {
        params: q,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}
/**
 * 获取用户列表
 * @param  {[type]} filter [description]
 * @return {[type]}        [description]
 */
function fetchUsers(filter) {
    var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    var token = _utils.ls.getItem('token');
    var q = _extends({}, filter);
    q.page = page;
    return _axios2.default.get(_constants.API_ENDPOINTS.users, {
        params: q,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

function postUser(values) {
    var token = _utils.ls.getItem('token');
    var data = {
        status: values.status
    };
    return _axios2.default.put(_constants.API_USERS + '/' + values.id, data, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

function fetchLevels(filter) {
    var token = _utils.ls.getItem('token');
    var q = _extends({}, filter);
    return (0, _isomorphicFetch2.default)(_constants.API_LEVELS + '?' + querystring.stringify(q), {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

/**
 * 用户登录表单提交操作
 * @param  {[object]} profile [mobile, password]
 * @return {[type]}         [description]
 */
function login(profile) {
    return _axios2.default.post(_constants.API_AUTH.signin, _extends({}, profile));
}

/**
 * 用户注册表单提交操作
 * @param  {[object]} profile [mobile, password, captcha]
 * @return {[type]}         [description]
 */
function register(profile) {
    var q = _extends({}, profile);
    return (0, _isomorphicFetch2.default)(_constants.API_AUTH.signup, {
        headers: {
            'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(q)
    });
}
/**
 * [获取短信验证码]
 * @param  {[type]} mobile [description]
 * @return {[type]}        [description]
 */
function fetchCaptcha(mobile) {
    return (0, _isomorphicFetch2.default)(_constants.API_AUTH.captcha + '?mobile=' + mobile);
}

/**
 * 获取自提点列表
 * @param  {[type]} filter [description]
 * @return {[type]}        [description]
 */
function fetchPickupStations(filter) {
    var token = _utils.ls.getItem('token');
    var q = _extends({}, filter);
    return (0, _isomorphicFetch2.default)(_constants.API_PICKUP_STATIONS + '?' + querystring.stringify(q), {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

/**
 * 获取运费模版列表
 * @param  {[type]} filter [description]
 * @return {[type]}        [description]
 */
function fetchShippingTemplates(filter) {
    var token = _utils.ls.getItem('token');
    var q = _extends({}, filter);
    return (0, _isomorphicFetch2.default)(_constants.API_SHIPPING_TEMPLATES + '?' + querystring.stringify(q), {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

/**
 * 获取媒体列表
 */
function fetchMedia() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var token = _utils.ls.getItem('token');
    var q = {
        page: options.page
    };
    return _axios2.default.get(_constants.API_UPLOADS + '?' + querystring.stringify(q), {
        params: {
            mime_type: 'image'
        },
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

// 上传图片
function postMedia(files, sign) {
    var token = _utils.ls.getItem('token');

    var config = {
        headers: {
            'Authorization': 'Bearer ' + token,
            'Content-Type': 'multipart/form-data'
        }
    };
    var result = Array.from(files).map(function (file) {
        var formData = new FormData();
        var data = {
            key: sign.dir + Date.now() + file.name.slice(-4),
            OSSAccessKeyId: sign.accessid,
            policy: sign.policy,
            signature: sign.signature,
            callback: sign.callback,
            file: file
        };
        for (var key in data) {
            if (data.hasOwnProperty(key)) {
                formData.append(key, data[key]);
            }
        }
        return _axios2.default.post(sign.host, formData, config);
    });

    return Promise.all(result);
}
/**
 * 获取图片上传签名
 */
function fetchUploadSign(isPublic) {
    var token = _utils.ls.getItem('token');
    return _axios2.default.get(_constants.API_UPLOAD_SIGN, {
        params: {
            access_permission: isPublic ? 'public' : 'private'
        },
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

/**
 * 订单发货
*/
function postPackage(info) {
    var token = _utils.ls.getItem('token');
    var data = {
        order_id: info.orderID,
        carrier: info.courier,
        tracking_number: info.number
    };
    return _axios2.default.post(_constants.API_ENDPOINTS.packages, data, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}
/**
 * 订单退款
*/
function postRefund(info) {
    var token = _utils.ls.getItem('token');
    var data = {
        order_id: info.orderID,
        refund_fee: info.fee
    };
    return _axios2.default.post(_constants.API_ENDPOINTS.refunds, data, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

/**
 * 控制面板统计订单数
*/
function fetchHomeData() {
    var token = _utils.ls.getItem('token');
    return _axios2.default.get(_constants.API_ENDPOINTS.home + '/dashboard', {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

/**
 * banner图数据查询接口
*/
function fetchBannerData() {
    var token = _utils.ls.getItem('token');
    return _axios2.default.get(_constants.API_BASE_URL + '/banners', {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

/**
 * banner图数据添加接口
*/
function updateBannerData(values) {
    var token = _utils.ls.getItem('token');
    return _axios2.default.post(_constants.API_BASE_URL + '/banners', values, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

/**
 * banner图数据删除接口
*/
function deleteBannerData(id) {
    var token = _utils.ls.getItem('token');
    return _axios2.default.delete(_constants.API_BASE_URL + '/banners/' + id, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

/**
 * reseller查询接口
*/
function fetchResellers() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    var token = _utils.ls.getItem('token');
    var params = {
        page: page
    };
    return _axios2.default.get(_constants.API_BASE_URL + '/resellers', {
        params: params,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

/**
 * 申请提现列表查询接口
*/
function fetchWithDraws() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

    var token = _utils.ls.getItem('token');
    var params = {
        page: page
    };
    return _axios2.default.get(_constants.API_BASE_URL + '/payments?type=6', {
        params: params,
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}

/**
 * 申请提现状态更改接口
*/
function updateWithDrawStatus(id) {
    var token = _utils.ls.getItem('token');
    var params = {
        id: id
    };
    return _axios2.default.post(_constants.API_BASE_URL + '/withdraw', params, {
        headers: {
            'Authorization': 'Bearer ' + token
        }
    });
}


//////////////////
// WEBPACK FOOTER
// ./src/js/api/index.js
// module id = 719
// module chunks = 0